import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import { NewCheckbox } from "../../../../shared-components";
import ErrorField from "./ErrorField";

const LegalConsentField = ({
  form,
  disableForm,
  onRadioBtnChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Legal consent");

  const subtitle = (
    <>
      <div className="subtitle">
        {/* prettier-ignore */ trans("I confirm the following: ")}
        <br />
        {/* prettier-ignore */ trans("I am not a direct employee of Wattpad or a Wattys Judge. (Note: other Independent Contractors and relatives of Wattpad employees are permitted to enter, though prize eligibility will be evaluated if shortlisted to ensure fairness).")}
        <br />
        <br />
        {/* prettier-ignore */ trans("If I am between 13 and 18 years old, I have parental/legal guardian permission to enter the contest.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("My story is original to me and does not violate anyone else's intellectual property rights.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("My account and entry are not generated by script, macro or other automated means.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("If I win the Wattys, I allow Wattpad to share my entry and other similar details in winner announcements.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I give Wattpad permission to use my publicly provided information on Wattpad (such as my pen name, Wattpad profile photo and Wattpad username), and other required information related to the Wattys for any advertising or publicity.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I acknowledge Participation Tiers (Full Eligibility, Recognition-Only, and Void Where Prohibited), understanding that my entry’s validity and my eligibility for physical or monetary prizes may be restricted by international sanctions (such as U.S. OFAC) or local laws in my jurisdiction.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I acknowledge that the Wattys are not connected to any social media platform.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I release Wattpad, their affiliates, partners and parent company, from claims related to the Wattys or any prizes awarded, which may arise now or in the future.")}
      </div>
    </>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "legalConsent" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    !form.legalConsent;

  return (
    <div className="legal-consent-container">
      <div className="legal-consent-title-container">
        <h4>{title}</h4>
      </div>
      {subtitle}
      <div className="checkbox-group" id="legal-consent-checkbox">
        <NewCheckbox
          disabled={disableForm}
          name="legalConsent"
          onChange={onRadioBtnChange}
          checked={form.legalConsent}
          contentId="legal-consent-checkbox-message"
        >
          {trans("I agree")}
        </NewCheckbox>
      </div>
      <ErrorField errorCondition={errorCondition} fieldId={"legal-consent"} />
    </div>
  );
};

LegalConsentField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onRadioBtnChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default LegalConsentField;
